<template>
    <div>
        <template v-if="manage_administrator == true && companies != null && roles != null">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Add Administrators</h1>
            </div>
            <div class="global-main">
                <div class="people-management-inner-content">
                    <form id="cityForm" @submit.prevent="addAdministrator">
                        <div class="tab-content-inner">
                            <div class="user-permissions">
                                <div class="form-group">
                                    <label> Company<span class="highlight-color">*</span> </label>
                                    <select v-model="form.company_id" @change="CompanyIdChange" data-live-search="true" name="company_id" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('company_id') }" v-if="companies != null">
                                        <option value="" selected>Select Company</option>
                                        <option v-for="company in companies" v-bind:value="company.id" v-bind:key="company.id">
                                            {{ company.name }}
                                        </option>
                                    </select>
                                    <has-error :form="form" field="company_id"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Name<span class="highlight-color">*</span> </label>
                                    <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                                    <has-error :form="form" field="name"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Mobile No.<span class="highlight-color">*</span> </label>
                                    <input v-model="form.mobile_no" type="number" name="mobile_no" class="form-control" :class="{ 'is-invalid': form.errors.has('mobile_no') }">
                                    <has-error :form="form" field="mobile_no"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> CNIC<span class="highlight-color">*</span> </label>
                                    <input v-model="form.cnic" type="number" name="cnic" class="form-control" :class="{ 'is-invalid': form.errors.has('cnic') }">
                                    <has-error :form="form" field="cnic"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> E-Mail Address<span class="highlight-color">*</span> </label>
                                    <input v-model="form.email" type="email" name="email" class="form-control" :class="{ 'is-invalid': form.errors.has('email') }">
                                    <has-error :form="form" field="email"></has-error>
                                </div>
                                <div class="form-group btn-holder">
                                    <div class="label-holder"> </div>
                                    <button class="btn btn-default" type="button" v-on:click="generateAdministratorPassword" style="padding:0 20px;">Generate new password</button>
                                </div>
                                <div class="form-group">
                                    <label> Password<span class="highlight-color">*</span> </label>
                                    <input v-model="form.password" type="password" name="password" placeholder="Password must contain Uppercase,Lowercase,Digits,Special characters. Example: 42-aBcdef" id="password" class="form-control" :class="{ 'is-invalid': form.errors.has('password') }">
                                    <i class="far fa-eye" id="togglePassword" @click="togglePassword()"></i>
                                    <has-error :form="form" field="password"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Confirm Password<span class="highlight-color">*</span> </label>
                                    <input v-model="form.password_confirmation" type="password" name="password_confirmation" id="password_confirmation" class="form-control toggleCPassword" :class="{ 'is-invalid': form.errors.has('password_confirmation') }">
                                    <has-error :form="form" field="password_confirmation"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Join Date<span class="highlight-color">*</span> </label>
                                    <datepicker name="join_date" v-model="form.join_date" input-class="form-control" :class="{ 'is-invalid': form.errors.has('join_date') }"></datepicker>
                                    <has-error :form="form" field="join_date"></has-error>
                                </div>
                                <label class="label block-label"> <span class="highlight-color"> Role </span><span class="highlight-color">*</span> </label>
                                <div class="form-group">
                                    <select v-on:change="getPermission($event)" v-model="form.role_id" name="role_id" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('role_id') }" v-if="roles != null">
                                        <option value="" selected>Select Role</option>
                                        <option v-for="role in roles" v-bind:value="role.id" v-bind:key="role.id">
                                            {{ role.name }}
                                        </option>
                                    </select>
                                    <has-error :form="form" field="role_id"></has-error>
                                </div>
                                <template v-if="permissions != null">
                                    <div class="form-group" v-for="(permission, index) in permissions" v-bind:key="permission.id">
                                        <label class="label block-label"> <span class="highlight-color">{{index}}</span> </label>
                                        <div class="permissions-box">
                                            <div class="row">
                                                <div class="col-md-4 mb-2" v-for="child in permission" v-bind:key="child.id">
                                                    <label class="check-holder ml-0">
                                                        <span class="check-text"> {{child.display_name}} </span> <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="child.description"></i>
                                                        <input type="checkbox" v-bind:value="child.id" v-bind:id="'permission_'+child.id" v-model="form.rolePermissions" />
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <div class="modal fade" id="getSharedCompanies" tabindex="-1" role="dialog" aria-labelledby="SharedCompanies" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                        <div class="modal-content">
                                            <div class="modal-body text-left p-1">
                                                <div>
                                                    <!-- Modal Header -->
                                                    <div class="modal-header">
                                                        <label class="label block-label"> Select Sub / Child companies to Share Ledger </label>
                                                    </div>
                                                    <!-- Modal body -->
                                                    <div class="modal-body">
                                                        <div class="alert alert-danger" v-if="errorMessage!==''">{{errorMessage}}</div>
                                                        <template v-if="sharedCompanies.length != 0">
                                                            <div class="form-group" v-for="(sharedCompany, index) in sharedCompanies" v-bind:key="sharedCompany.id">
                                                                <label class="check-holder ml-0">
                                                                    <span class="check-text"> {{sharedCompany.name}} </span> <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="sharedCompany.name"></i>
                                                                    <input type="checkbox" v-bind:value="sharedCompany.id" v-model="form.selectedSharedCompanies" />
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            No Sub/Child Company Found!
                                                        </template>
                                                    </div>
                                                    <!-- Modal footer -->
                                                    <div class="modal-footer p-1">
                                                        <div class="row normal-ib-space mt-3">
                                                            <div class="col"> <button class="btn btn-primary" data-dismiss="modal" aria-label="Close"> Cancel </button> </div>
                                                            <div class="col"> <button :disabled="form.busy" class="btn btn-primary active"> Submit </button> </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="page-top mb-1 mb-3 mt-4 clearfix">
                                    <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                                    <router-link to="/administrators" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </template>
        <template v-else-if="manage_administrator === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="manage_administrator === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    company_id : '',
                    mobile_no : '',
                    cnic : '',
                    name : '',
                    email : '',
                    password : '',
                    password_confirmation : '',
                    join_date : new Date(),
                    role_id : '',
                    rolePermissions : [],
                    userPermissions : [],
                    selectedSharedCompanies: []
                }),
                role : {},
                permissions : null,
                category : null,
                companies: null,
                roles: null,
                employeeRolesId: null,
                manage_administrator: null,
                sharedCompanies: [],
                errorMessage: ''
            }
        },
        mounted() {
            this.$Progress.start();
            this.can('manage_administrator').then(result => {
                this.manage_administrator = result.manage_administrator;
            }).then(result => {
                if(this.manage_administrator == true){
					this.getAddAdministratorData();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });

        },
        methods: {
            CompanyIdChange: function(val, oldVal) {
                this.form.selectedSharedCompanies = [];
            },
            setEmployeeRole() {
                var event = { target : { value : this.employeeRolesId } };
                this.getPermission(event);
                this.form.role_id = this.employeeRolesId;
            },
            addAdministrator() {
                this.$Progress.start();
                this.form.post('api/addAdministrator')
                .then(res => {
                    if(res.status == 200){
                        console.log(res);
                        if(res.data.code == 201) {
                            this.sharedCompanies = res.data.companies;
                            $('#getSharedCompanies').modal('show');    
                            this.showToastBox('warning',res.data.message);
                        } else {
                            $('#getSharedCompanies').modal('hide');      
                            this.$Progress.finish();
                            this.showToastBox('success',res.data.message);
                            this.$router.push('/administrators');
                        }
                    } else {
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some error in your form data');
                });
            },
            getAddAdministratorData(){
                this.$Progress.start();
                axios.get('/api/addAdministratorData')
                .then(res => {
                    if(res.status == 200){
                        this.companies = res.data.companies;
                        this.roles = res.data.roles;
                        this.employeeRolesId = res.data.employeeRolesId;
                        this.permissions = res.data.permissions;
                        this.pageView = res.data.pageView;
                        this.$Progress.finish();
                        this.setEmployeeRole();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                }).then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.showAlertBox('error','Some error in your form data');
                });
            },
            getPermission(event) {
                this.$Progress.start();
                axios.get('/api/getRolePermissionData/'+event.target.value)
                .then(res => {
                    if(res.status == 200){
                        this.form.rolePermissions = [];
                        $.each(res.data.permissions, (key, value) => {
                            this.form.rolePermissions.push(value.id);
                            this.form.userPermissions = this.form.rolePermissions;
                        });
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some error in your form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some error in your form data');
                });
            },
            generateAdministratorPassword() {
                var retVal = this.generatePassword();
                this.form.password = retVal;
                this.form.password_confirmation = retVal;
            },
            togglePassword(){
                const togglePassword = document.querySelector('#togglePassword');
                const password = document.querySelector('#password');
                const cpassword = document.querySelector('#password_confirmation');
                const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
                password.setAttribute('type', type);
                cpassword.setAttribute('type', type);
                // toggle the eye / eye slash icon
                togglePassword.classList.toggle('fa-eye-slash');
            }
        }
    }
</script>
